import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getAllUnits } from 'service/api';

// Constants - action names
export const UNITS = 'pv-kultu/units/UNITS';
export const UNITS_SUCCESS = 'pv-kultu/units/UNITS_SUCCESS';
export const UNITS_FAILED = 'pv-kultu/units/UNITS_FAILED';

// Helpers
//--

// Initial state
const initialState = {
  unitsList: [],
  loading: false,
  error: undefined
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UNITS:
      return Object.assign({}, state, {loading: true});
    case UNITS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        unitsList: action.unitsList
      });
    case UNITS_FAILED:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state;
  }
}

// Actions
export function getUnits() {
  return {type: UNITS};
}

export function getUnitsSuccess(data) {
  return {type: UNITS_SUCCESS, unitsList: data};
}

export function getUnitsFailed(error) {
  return {type: UNITS_FAILED, error};
}

// Sagas
/*
takeEvery   // allows concurrent fetchData instances
takeLatest  // only the latest call will run
 */
function* fetchData() {
  try {
    const data = yield call(getAllUnits);
    yield put(getUnitsSuccess(data));
  } catch (error) {
    yield put(getUnitsFailed(error));
  }
}

function* watchFetchData() {
  yield takeEvery(UNITS, fetchData);
}

export function* unitsSagas() {
  yield all([
    watchFetchData()
  ]);
}


// WEBPACK FOOTER //
// ./src/ducks/units.js